const types = {
  FETCH_DATASET_BY_NAME: "FETCH_DATASET_BY_NAME",
  FETCH_DATASET_FAILURE: "FETCH_DATASET_FAILURE",
  CREATE_DATASET: "CREATE_DATASET",
  UPLOAD_ATTACHMENT: "UPLOAD_ATTACHMENT",
};

export const datasetFailure = `${types.FETCH_DATASET_FAILURE}`;
export const fetchDatasetRequest = `${types.FETCH_DATASET_BY_NAME}_REQUEST`;
export const fetchDatasetSuccess = `${types.FETCH_DATASET_BY_NAME}_SUCCESS`;

export const createDatasetRequest = `${types.CREATE_DATASET}_REQUEST`;
export const createDatasetSuccess = `${types.CREATE_DATASET}_SUCCESS`;

export const uploadAttachmentRequest = `${types.UPLOAD_ATTACHMENT}_REQUEST`;
export const uploadAttachmentSuccess = `${types.UPLOAD_ATTACHMENT}_SUCCESS`;

export const dispatchFetchDatasetRequest = () => ({
  type: fetchDatasetRequest,
});

export const dispatchFetchDatasetSuccess = (data: any) => ({
  type: fetchDatasetSuccess,
  data,
});
export const dispatchDatasetFailure = () => ({
  type: datasetFailure,
});

export const dispatchCreateDatasetRequest = () => ({
  type: createDatasetRequest,
});

export const dispatchCreateDatasetSuccess = (data: any) => ({
  type: createDatasetSuccess,
  data,
});

export const dispatchUploadAttachementRequest = () => ({
  type: uploadAttachmentRequest,
});

export const dispatchUploadAttachementSuccess = (data: any) => ({
  type: uploadAttachmentSuccess,
  data,
});
